import { DBConfig } from './DBConfig';

class IndexedDB {

    static init() {
        return new Promise((resolve, reject) => {
            let database = DBConfig;
            let request = window.indexedDB.open(database.name, database.version);

            request.onupgradeneeded = event => {
                var db = event.target.result;

                // Create an objectStore to hold information about our smarguideDB
                var objectStore = db.createObjectStore("audios", {keyPath: "name"});
                var objectStoreVisited = db.createObjectStore("visited", {keyPath: "name"});
                objectStore.add(database.data);
                objectStoreVisited.add(database.visited);
            };

            request.onsuccess = event => {
                event.target.result.close();
                resolve();
            };

            request.onerror = event => {
                reject(event.target.error);
            };
        });
    }

    static deleteDatabase() {
        return new Promise((resolve, reject) => {
            const request = window.indexedDB.deleteDatabase(DBConfig.name);

            request.onsuccess = () => {
                resolve();
            };

            request.onerror = event => {
                reject(event.target.error);
            };

            request.onblocked = () => {
                resolve();
            };
        });
    }

    static update(newData) {
        return new Promise((resolve, reject) => {
            let database = DBConfig;
            let request = window.indexedDB.open(database.name, database.version);

            request.onsuccess = event => {
                const db = event.target.result;
                const transaction = db.transaction("audios", "readwrite");
                const objectStore = transaction.objectStore('audios');
                const objectStoreRequest = objectStore.put({name: "smartguide_audios", value: newData});

                objectStoreRequest.onsuccess = () => {
                    resolve(newData);
                };

                objectStoreRequest.onerror = event => {
                    reject(event.target.error);
                };

                transaction.oncomplete = () => {
                    db.close();
                };

                transaction.onerror = event => {
                    reject(event.target.error);
                };
            };

            request.onerror = event => {
                reject(event.target.error);
            };
        });
    }

    static updateVisited(id) {

        let database = DBConfig;
        let request = window.indexedDB.open(database.name, database.version);
        request.onsuccess = event => {
            const db = event.target.result;
            const transaction = db.transaction("visited", "readwrite");
            const objectStore = transaction.objectStore('visited');
            const requestJsonDataObjectStoreData = objectStore.get("smartguide_visited");
            requestJsonDataObjectStoreData.onsuccess = event => {
                let visitedArray = event.target.result.value;
                let newData = visitedArray ? visitedArray : {};
                newData[id] = true;
                const objectStoreRequest = objectStore.put({name: "smartguide_visited", value: newData});
            };

        };
    }

    static get() {
        return new Promise((resolve, reject) => {
            let database = DBConfig;
            let request = window.indexedDB.open(database.name, database.version);

            request.onsuccess = event => {
                let db = event.target.result;
                let objectStore = db.transaction("audios", "readonly").objectStore("audios");
                let requestJsonDataObjectStoreData = objectStore.get("smartguide_audios");

                requestJsonDataObjectStoreData.onsuccess = event => {
                    const result = event.target.result;
                    db.close();
                    resolve(result ? result.value : null);
                };

                requestJsonDataObjectStoreData.onerror = event => {
                    db.close();
                    reject(event.target.error);
                };
            };

            request.onerror = event => {
                reject(event.target.error);
            };
        });
    }

    static getVisited() {
        return new Promise((resolve, reject) => {
            let database = DBConfig;
            let request = window.indexedDB.open(database.name, database.version);

            request.onsuccess = event => {
                let db = event.target.result;
                const transaction = db.transaction("visited", "readonly");
                const objectStore = transaction.objectStore('visited');
                const requestJsonDataObjectStoreData = objectStore.get("smartguide_visited");

                requestJsonDataObjectStoreData.onsuccess = event => {
                    const result = event.target.result;
                    db.close();
                    resolve(result ? result.value : {});
                };

                requestJsonDataObjectStoreData.onerror = event => {
                    db.close();
                    reject(event.target.error);
                };
            };

            request.onerror = event => {
                reject(event.target.error);
            };
        });
    }

    databaseError() {
        console.error('Error');
    }

}
;

export default IndexedDB;
